export default __webpack_public_path__ + "static/button-label-do-41e66874ff9c3ec06dc9079aad43a8501c19d4169c7efeff8ebe55311a5752a8.png";